export default {
  relax: {
    title: 'Dynamic Stretching',
    subTitle: null,
    text: [
      'This body movement session goes through a full range of motion and specific bodily postures. It will reduce muscle tension while increasing your range of movement and flexibility. Great after a flight, it promotes stress relief and boosts your energy levels.'
    ]
  },
  powerwalk: {
    title: 'Power Walking',
    subTitle: '*This can be done as a private training session.',
    text: [
      'Power Walking is simple, enjoyable and can be done virtually anywhere! When done right, walking can blast away fat as fast as jogging and improve your body\'s conditioning to provide better endurance for carrying out daily tasks.'
    ]
  },
  tabata: {
    title: 'Tabata Training',
    subTitle: '*This can be done as a private training session.',
    text: [
      'Tabata is an enhanced, high-intensity interval training session that can be done in 30 minutes. These short, intense workouts are great for fat burning, increasing metabolism and improved athleticism.'
    ]
  },
  caribnbchs: {
    title: 'Caribbean Beach Shred',
    subTitle: '*This can be done as a private training session.',
    text: [
      'This high intensity workout combines fat-burning techniques and total-body sculpting moves all at the same time for maximum efficiency. You will shed unwanted calories, accelerate your heart rate and increase your metabolism while still enjoying our Caribbean Beach.'
    ]
  },
  aquatabata: {
    title: 'Aqua Tabata',
    subTitle: '*This can be done as a private training session.',
    text: [
      'Don\'t feel like leaving the pool? NO PROBLEM... Aqua Tabata is a water-based, high intensity training class. You will achieve a full body workout with cardio, resistance and core training.'
    ]
  },
  aqua: {
    title: 'Aqua Fitness',
    subTitle: '*This can be done as a private training session.',
    text: [
      ' Aqua Fitness is resistance training session performed in a swimming pool. This exercise is low impact on your joints and allows for greater movement and flexibility than you would have on dry land.'
    ]
  },
  splish: {
    title: 'Splish-Splash',
    subTitle: null,
    text: [
      'Kids naturally love water, so why not introduce them to water aerobics? Splish-Splash offers a fun, physically intense, low impact class. Great for overall cardiovascular health, kids enjoy splashing and kicking in the water while simultaneously improving their fitness levels.'
    ]
  },
  beachfun: {
    title: 'Kids Beach FUN',
    subTitle: null,
    text: [
      'A high-energy exercise class designed specifically for children, Beach Fun Fitness incorporates obstacle courses, fitness games, partner activities, body weight exercises, and circuits to improve children\'s overall health in a fun, safe and motivating environment. Kids also learn to create a positive association with fitness, which leads to healthy adult habits for life.'
    ]
  },
  gymasst: {
    title: 'Gym Assistance',
    subTitle: null,
    text: [
      'Gym equipment can seem a little intimidating or you may need someone to \'spot\' you. Our Fitness pros are there to show you how to use the equipment or to simply give a helping hand.'
    ]
  },
  jammin: {
    title: 'Jammin!!!',
    subTitle: '*This can be done as a private training session.',
    text: [
      'Jammin!!! is a high energy, music infused cardio blast, bringing together Latin, Caribbean and American dance music to help you burn calories and have a great time!'
    ]
  },
  yoga: {
    title: 'Yoga',
    subTitle: '*At select resorts only.',
    text: [
      'Practiced worldwide, yoga reduces stress, increases stamina and builds core strength. Whether you\'ve never tried Yoga or you\'re an avid enthusiast, our basic Yoga class offers a great way to relax while simultaneously improving your health. Join us to begin enjoying the various benefits of Yoga, today.',
      <span>*Private Training sessions come at an additional cost.</span>
    ]
  },
  couplesstrch: {
    title: 'Couples Stretching Session',
    subTitle: '*This can be done as a private training session.',
    text: [
      'Couples Stretching maintains and increases your range of motion and flexibility by increasing blood flow to the muscles. You will notice improved movement, reduced muscle soreness, and improved physical performance. This is a great way to connect with that special someone and take your relationship to the next level.'
    ]
  },
  begginer: {
    title: 'Tennis Clinic - Beginners',
    subTitle: null,
    text: [
      'This clinic is for those with limited or no experience playing Tennis. You are primarily working to keep the ball in play.   Learn proper grips, footwork and  techniques for groundstrokes, net play and serves will be introduced. You will learn basic court positioning and how to keep score in a tennis match.'
    ]
  },
  absoluteabs: {
    title: 'Absolute Abs',
    subTitle: '*At select resorts only',
    text: [
      'Designed for all fitness levels, this 30-minute workout specifically targets your core area to help you build sexy, beach-ready abs. A strong abdominal region is extremely important to stabilize the spine and improve overall strength. Start your morning with a challenging workout and feel empowered the entire rest of the day!',
      <span>*Private Training sessions come at an additional cost.</span>
    ]
  },
  field: {
    title: 'Advanced Tennis Clinic',
    subTitle: null,
    text: [
      'For our guests who are comfortable playing a full, regular singles or doubles tennis match. You can sustain a 10-shot baseline to baseline rally on the singles court, although you generally lack depth and directional control on your groundstrokes. You come to the net on a short ball, although your approach shot may not challenge your opponent. You can make most of your volleys but may not feel comfortable at the net. You rarely double fault but your second serve is weak OR you double fault often going for too much on both serves. You are developing teamwork in doubles tennis.'
    ]
  },
  teeenstennis: {
    title: 'Teens & Tweens Tennis clinic',
    subTitle: null,
    text: [
      'Whether learning just for fun or with the aspiration of making it onto a high school tennis team, this is the ideal class! It is designed for teens and tweens who want to learn the basic skills of tennis, as well as those who want to develop their skills further.'
    ]
  },
  hitpro: {
    title: 'Hit with the Pro',
    subTitle: null,
    text: [
      'Get on the court and as the name suggests, hit with the Pro! A hitting session will assist the Pro in determining your proficiency, after which you will be engaged in a match suitable for your skill level.'
    ]
  },
  basketball: {
    title: 'BasketBall',
    subTitle: null,
    text: [
      'Like any team sport, basketball can get competitive and serious, but it\'s meant to be fun! Our Fitness Pros put the fun back in the game, giving beginners the opportunity to learn the fundamentals of the sport, and honing the skills of the more experienced players.'
    ]
  },
  kidstennis: {
    title: 'Kids Tennis FUN Time',
    subTitle: null,
    text: [
      'Kids Tennis FUN Time introduces the sport of tennis in a fun and interactive way. Using modified tennis balls & racquets, young players are properly equipped to enjoy rallies and learn the fundamentals of the game early on. Skills are developed much quicker, allowing for an easy transition to full court.'
    ]
  },
  personaltrng: {
    title: 'PRIVATE PERSONAL TRAINING SESSION',
    subTitle: '*Private Training sessions come at an additional cost.',
    text: [
      'Personal Training is a private session with our Red Lane Fitness Pro who will enhance your current workout or establish a new fitness regime based upon your personal fitness goals. Any of our complimentary group classes can be done as a private one-on-one or group session.'
    ]
  },
  singletourn: {
    title: 'Singles Tennis Tournament',
    subTitle: null,
    text: [
      'This involves two sets of players at the same tennis level competing against each other, usually two men or two women, although games between a man and a woman may be played on an informal basis.'
    ]
  },
  doubletourn: {
    title: 'Double Tennis Tournament',
    subTitle: null,
    text: [
      'In this type of tennis competition there are a total of four tennis players involved. Two tennis players combine forces to compete as a team, challenging another team of two.'
    ]
  },
  streching: {
    title: 'Stretching Session',
    subTitle: '*This can be done as a private training session.',
    text: [
      'This body movement session goes through a full range of motion and specific bodily postures. It will reduce muscle tension while increasing your range of movement and flexibility. Great after a flight, it promotes stress relief and boosts your energy levels.'
    ]
  },
  zumba: {
    title: 'Zumba',
    subTitle: '*At select resorts only.',
    text: [
      'Dance to the rhythms of Latin music while blasting away calories. This fun aerobic fitness program incorporates dance and strength training exercises, all choreographed along to hip-hop, soca, samba, salsa, merengue, bachata and mambo. Not only will you learn sassy dance moves, but also build your anaerobic endurance. This entertaining class is a guaranteed win-win.',
      <span>*Private Training sessions come at an additional cost.</span>
    ]
  },
  abssn: {
    title: 'Abs Session',
    subTitle: null,
    text: [
      'Designed for all fitness levels, this 30-minute workout specifically targets your core area to help you build sexy, beach-ready abs. A strong abdominal region is extremely important to stabilize the spine and improve overall strength. Start your morning with a challenging workout and feel empowered for the rest of the day!'
    ]
  }
};
